import { render, staticRenderFns } from "./simKefu.vue?vue&type=template&id=44ddae48&scoped=true&"
import script from "./simKefu.vue?vue&type=script&lang=js&"
export * from "./simKefu.vue?vue&type=script&lang=js&"
import style0 from "./simKefu.vue?vue&type=style&index=0&id=44ddae48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44ddae48",
  null
  
)

export default component.exports